export default __webpack_public_path__ + "static/media/Ravenclaw Tasset.dcbb4745.jpg";